import apiCaller from '../utils/api-caller';

// onboarding related

export function ParentSetupApi(params) {
  return apiCaller({ path: '/web_api/parent/v1/setup', params: params });
}

export function ParentSetupSplashcourseApi() {
  return apiCaller({ path: '/web_api/parent/v1/setup_splashcourse' });
}

export function VerifyEmailApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/verify_email', params: params });
}

// [AI GENERATED CODE] SL-20161: Added tr_sub_source propagation to API payload
export function LinkPTLStudentApi(params){
  return apiCaller({method: 'post', path: '/ptl-setup/link-student', params: {...params, rejectWithErrorObject: true}});
}

//verify entered class code and gives a list of students corresponding to entered class code (PTL Signup through common link)
export function VerifyAndListStudentsApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student_list', params: params });
}

//add student to ParentHomeApi api after passing student id as params
export function AddStudentToParentApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/add_student_to_parent', params: params });
}

export function SavePasswordApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/save_password', params: params });
}

export function ChangeEmailApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/change_email', params: params });
}

export function ResendOtpApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/resend_otp', params: params });
}

export function GenerateOtpApi(params) {
  return apiCaller({ method: 'post', path: '/account/generate_otp', params: params });
}

export function VerifyEmailToLoginApi(params) {
  return apiCaller({ method: 'post', path: '/account/verify_email', params: params });
}

export function ResendOtpForLoggedoutApi(params) {
  return apiCaller({ method: 'post', path: '/account/resend_otp', params: params });
}

export function getSavedCards() {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/account/saved_cards' });
}

export function SetGradeApi(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/set_grade', params: params, hideSpinner: hideSpinner });
}

export function SetAgeApi(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/set_age', params: params, hideSpinner: hideSpinner });
}
export function MarkAgeSelectionApi() {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/set_onboarding_states_age' });
}

export function SetFocusAreaApi(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/set_focus_area', params: params, hideSpinner });
}

export function TrackWeeklyGoalOnboarding(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/track_weekly_goal_onboarding' });
}

export function ParentHomeApi() {
  return apiCaller({ path: '/web_api/parent/v1/home' });
}

export function ReportApi(params) {
  apiCaller({ method: 'put', baseUrl: '', path: '/parents/' + params.id + '/send_parent_app_install_email' });
}

export function CreatePasswordApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/set_password', params: params })
}

export function KlassCodeLogin() {
  return apiCaller({ method: 'get', path: '/parent/klass_code_login', params: { parent_with_klass_code: true } });
}
// params:  student_id
export function EditStudentApi(params) {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/student/edit', params: params });
}

// params: course_id, grade_id, content_group_ids, avatar, name
export function SaveStudentApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/save_student', params: params });
}
export function SaveStudentAvatarsApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/save_new_avatars', params: params });
}

export function SwitchStudentApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/set_active_student', params: params });
}
export function RemindPasscodeApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/remind_passcode', params: params });
}
export function SaveProfileApi(params, hideSpinner) {
  return apiCaller({ method: 'put', path: '/web_api/parent/v1/profile', params: params, hideSpinner: hideSpinner })
}

export function SetWeeklyScheduleApi(params, userTargetId) {
  return apiCaller({ method: 'put', path: `/parent/parent_student_targets/${userTargetId}`, params: params });
}

export function GetUserTaget(params) {
  return apiCaller({ method: 'get', path: '/parent/parent_student_targets', params: params })
}
// Purchase related api.

export function SaveCreditCardApi(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/save_credit_card', params: params, hideSpinner: hideSpinner });
}
export function ProductListApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/product_list', params: params });
}

export function GetClientSecret(params) {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/get_client_secret', params: params });
}

export function studentProductList() {
  return apiCaller({ method: 'get', path: '/web_api/student/v2/products_list' });
}

export function createParentAndAddChild(params){
  const signupPageUrlFromFE = window?.location?.href.includes("/purchase") ? "/purchase" : window.location.pathname;
  document.cookie = `signup_page_url=${signupPageUrlFromFE}; path=/`;
  return apiCaller({method: 'post', path:'/create_parent_and_add_child', params: params});
}


export function SetupIntent(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/setup_intent', params: params, hideSpinner });
}

export function saveDefaultPaymentMethod(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/default_payment_method', params: params });
}

export function deletePaymentMethod(params) {
  return apiCaller({ method: 'delete', path: '/web_api/parent/v1/payment_method', params: params });
}

export function savedPaymentMethods(params) {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/payment_methods', params: params });
}

export function AttachPaymentMethodIdWithCustomer(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/attach_payment_intent', params: params });
}

export function SubscribeProductApi(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/subscribe_product', params: params, hideSpinner: hideSpinner });
}

export function CreateSubscription(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/create_subscription', params: params, hideSpinner: hideSpinner });
}
export function ActivateSubscription(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/activate_subscription', params: params, hideSpinner: hideSpinner });
}
// [AI GENERATED CODE] renew_flow (different-product) dedicated routes — replace the generic
// subscribe_product/create_subscription/activate_subscription + renewal_source tag approach.
export function SubscribeProductRenewalApi(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/renewal/subscribe_product', params: params, hideSpinner: hideSpinner });
}
export function CreateSubscriptionRenewal(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/renewal/create_subscription', params: params, hideSpinner: hideSpinner });
}
export function ActivateSubscriptionRenewal(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/renewal/activate_subscription', params: params, hideSpinner: hideSpinner });
}
// [AI GENERATED CODE] Fetch the parent's subscriptions (web). Mirrors the web branch of the Flutter
// WebAPI.fetchSubscriptionForParent. Returns { subscriptions, student_subscriptions }.
// params = { parent_id, via_remote_login? }.
export function fetchSubscriptionForParent(params, hideSpinner) {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/subscriptions', params: params, hideSpinner: hideSpinner });
}

export function MigrateGuestParent(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/migrate_guest_parent', params: params });
}

export function SubmitOnboardingSurvey(params, hideSpinner) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/submit_onboarding_survey', params: params, hideSpinner });
}

export function ValidateOfferCode(params) {
  return apiCaller({ method: 'post', path: '/validate_offer_code', params: params });
}

export function grantProductAccess(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/grant_product_access', params: params });
}

export function CompleteOnboarding(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/account/complete_onboarding', params: params });
}

export function FetchAllStudents() {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/fetch_all_students' });
}

export function InitiateParentDashboardSession() {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/start_session' });
}

export function TerminateParentDashboardSession() {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/end_session' });
}

export function UpdatePreviewCount() {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/update_preview_count' });
}

export function SubmitMigrationFeedback(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/submit_migration_feedback', params: params });
}
export function GetAutoLoginUrl() {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/autologin_url' });
}

//api to delink child from parent
export function UnlinkChildApi(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/unlink', params: params });
}

export function getCardsCompletedToday(params) {
  return apiCaller({ method: 'get', path: '/web_api/exploratory_games_service/v1/cards_completed_today_ela/' + params.user_id, params: { time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone } });
}

export function GetMentorTags() {
  return apiCaller({ method: 'get', path: '/web_api/parent/v1/mentor_tags' });
}

export function PtlMentorSessionBooked(params) {
  return apiCaller({ method: 'post', path: '/parent/set_ptl_learning_partner_session_booked_once', params: params });
}

export function FetchCgRecommendationStatus(params) {
  console.log('params in api', params);
  return apiCaller({ method: 'post', path: `${BASE_API_GATEWAY_URL}/curriculum_service/public/api/v1/cg_recommendation/status?user_id=${params.user_id}&course_id=${params.course_id}`, params: params, extServiceFlag: true });
}
//&cg_code=${params.cgCode} 

// api to fetch the ab tests
export function FetchNewABTests(params) {
  return apiCaller({
    method: 'get',
    path: `${BASE_API_GATEWAY_URL}/abtest-service/api/v1/users/${params.userId}/get-all-assigned-ab-tests`,
    extServiceFlag: true
  });
}

export function AssignAbTests(userId, params) {
  return apiCaller({
    method: 'post', path: `${BASE_API_GATEWAY_URL}/abtest-service/api/v1/users/${userId}/assign-all-ab-tests`, params: params,
    extServiceFlag: true
  });
}

export function XmasPopupShowOnce(params) {
  return apiCaller({ method: 'post', path: '/parent/set_xmas_popup_shown_once', params: params });
}

export function UserOnboardingDetails(params) {
  return apiCaller({ method: 'post', path: `${BASE_API_GATEWAY_URL}/curriculum_service/public/api/v1/users/${params.id}/user_onboarding_details?age=${params.age}&grade_code=${params.grade_code}`, params: params, extServiceFlag: true })
}

// springboard certificates apis
export function getWonSBCertificates(studentId, contestId) {
  return apiCaller({
    method: 'get',
    path: `${BASE_API_GATEWAY_URL}/contest-service/api/v1/students/${studentId}/contests/${contestId}/certificates/won`,
    extServiceFlag: true,
    hideSpinner: true
  });
}

export function getCertificateSeedData(studentId, contestId) {
  return apiCaller({
    method: 'get',
    path: `${BASE_API_GATEWAY_URL}/contest-service/api/v1/students/${studentId}/contests/${contestId}/certificates/seed-data`,
    extServiceFlag: true,
    hideSpinner: true
  });
}

export function getPreferredTimeSlot(parentId) {
  return apiCaller({ method: 'get', path: `${BASE_API_GATEWAY_URL}/live-class/users/live_class_preferred_time_slot?user_id=${parentId}`, extServiceFlag: true })
}

/// Post user respone on personalise page while onboarding
export function savePersonalisationIntent(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/save_personalization_intent', params: params });
}

export function getContestData() {
  return apiCaller({
    method: 'get',
    path: `${BASE_API_GATEWAY_URL}/contest-service/api/v1/contests`,
    extServiceFlag: true
  });
}

// book library apis
export function bookReadingLogs(params) {
  return apiCaller({
    method: 'post',
    path: `${BASE_API_GATEWAY_URL}/exploratory-games-service/api/v1/parents/user-book-reports/students/${params.studentId}/book-reading-logs`,
    params: params.params,
    extServiceFlag: true,
    hideSpinner: true
  });
}

export function fetchSchoolYearSummary(params) {
  return apiCaller({
    method: 'get',
    path: `${BASE_API_GATEWAY_URL}/exploratory-games-service/api/v1/parents/user-book-reports/students/${params.studentId}/school-year-activity`,
    extServiceFlag: true,
    hideSpinner: true
  });
}

export function fetchWeeklySummary(params) {
  return apiCaller({
    method: 'post',
    path: `${BASE_API_GATEWAY_URL}/exploratory-games-service/api/v1/parents/user-book-reports/students/${params.studentId}/weekly-summary`,
    params: params.params,
    extServiceFlag: true,
    hideSpinner: true
  });
}

export function fetchParentNPSSurveyData () {
  return apiCaller({method: 'get', path: '/web_api/parent/v1/profile/parent_nps_survey'})
 }

// Function to get redirect URL for role switching via backend service
export function getRedirectURL(params) {
  return apiCaller({
    method: 'post',
    path: '/web_api/v1/redirects/switch_role',
    params: params,
    extServiceFlag: true,
    hideSpinner: true
  });
}


// [AI GENERATED CODE]
export function deactivateUser(params) {
  return apiCaller({ method: 'post', path: '/web_api/parent/v1/student/deactivate', params: params });
}